import { apiRequest } from "@core/services/api/apiRequest";
import { VIDEO_API } from "../videoMeeting.constants";
import type { MeetingDetails } from "../videoMeeting.types";

export const fetchVideoMeetingDetails = async (
  meetingId: number | string
): Promise<MeetingDetails> => {
  return apiRequest(VIDEO_API.MEETING_DETAILS(meetingId), "GET");
};
